export class ShiftAssignment {
    Id: number;
    EmployeeId: number;
    EmployeeName: string;
    ShiftScheduleId: number;
    ShiftScheduleName: string;
    StartDate: Date;
    EndDate: Date;
    StartTime: string;
    EndTime: string;
    ValidFlag: boolean;
    CreatedBy: string;
    CreatedOn: Date;
    UpdatedBy: string;
    UpdatedOn?: Date;
    RowNum: number;
    Total: number;
    IsInserting?: boolean;
    IsAutoNumbering?: boolean;
    EmployeeIds: any[] = [];
}